var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "advocacy-standard" }, [
    _c(
      "section",
      { staticClass: "section filter-section", class: _vm.contentBackground() },
      [
        _vm.filters
          ? _c("filter-sidebar", { attrs: { filters: _vm.filters } })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("section", { staticClass: "cards card--list section" }, [
      _c("div", { staticClass: "global-container" }, [
        _c("div", { staticClass: "list-row row" }, [
          _vm.listing.length > 0
            ? _c(
                "div",
                { staticClass: "advocacy-items-wrapper items-wrapper" },
                [
                  _c(
                    "fragment",
                    _vm._l(_vm.listing, function(item, index) {
                      return _c("advocacy-alert-item", {
                        key: item.DetailID,
                        attrs: {
                          item: item,
                          displaySummary: _vm.displaySummary
                        }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.pagination && _vm.pagination.totalPages > 1
                    ? _c(
                        "section",
                        {
                          staticClass: "padding-top padding-bottom pagination",
                          class: _vm.contentBackground()
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "global-container" },
                            [_c("pagination")],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "advocacy-items-wrapper items-wrapper no-result",
                  class: _vm.contentBackground()
                },
                [
                  _vm.noresultsmsg
                    ? _c("fragment", [_c("richtext-content")], 1)
                    : _c("fragment", [
                        _c("h3", { staticClass: "not-found-heading h4" }, [
                          _vm._v(
                            "Sorry, no results were found matching your specifications."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Try removing some filters or searching a different term."
                          )
                        ])
                      ])
                ],
                1
              )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }